import Vue from 'vue'
import Vuex from 'vuex'
import { state, mutations,actions,getters } from './mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js